module.exports = __webpack_public_path__ + "static/media/calendar-alt.58ed0632.svg";